<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :center="true"
      title="结算"
      :visible.sync="payVisible"
      fullscreen
      :before-close="closeEvent"
    >
      <div class="js-neirong">
        <div class="swpay-content">
          <div class="js-mbinfo">
            <span>{{member&&member.memberName?member.memberName:'散客'}}</span>
            <div class="js-mbcard" v-if="memberCard&&memberCard.id">
              <span>会员卡</span>
              <span class="jssp">{{memberCard.cardName}}<span class="jsmd">({{memberCard.deptName}})</span></span>
              <span class="jssp">余额 {{memberCard.balance}}</span>
              <span class="jssp">赠送金 {{memberCard.giveBalance}}</span>
            </div>
          </div>
          <div class="swpay-left">
            <div class="consumption">
              <span class="yi-left">消费总额:</span>
              <span class="yi-right">{{ "￥" + totalAmount }}</span>
            </div>
            <div class="consumption">
              <span class="yi-left">折后支付:</span>
              <span class="yi-right" style="color: #e82742">{{
                "￥" + totalAmount
              }}</span>
            </div>
            <div class="consumption">
              <span class="date-left">
                <el-radio v-model="radio" :label="1">开单</el-radio>
                <el-radio v-model="radio" :label="2" v-if="checkPermission('bdqx')">补单</el-radio>
              </span>
              <span class="date-right">
                 <el-date-picker
                   v-if="radio==2"
                   size="small"
                   value-format="yyyy-MM-dd HH:mm:ss"
                   v-model="createTime"
                   type="datetime"
                   placeholder="选择日期时间">
                 </el-date-picker>
              </span>
            </div>
            <div class="consumption1">
              <div class="date-left1">
                <div>手工单号:</div>
                <div class="dfsgno">
                  <div v-for="(item,index) in sgnos" style="margin: 3px">
                    <span style="width: 100px;display: inline-block">
                       <el-input placeholder="单号" v-model="item.sgNo" size="mini"/>
                    </span>
                    <span style="margin-left: 10px;cursor: pointer;font-size: 10px;color: #ee0a24"
                          @click="delSgno(index)">删除</span>
                  </div>
                </div>
              </div>
              <span class="date-right1">
                <span style="margin-right: 20px;cursor: pointer;text-align: right" @click="addSgno">+</span>
              </span>
            </div>
            <div class="swpay-choice">
              <span style="width: 130px;padding-left: 40px;line-height: 85px">支付方式:</span>
              <div class="mode">
                <div class="mode1">
                  <div
                    style="cursor: pointer;"
                    class="icon"
                    v-for="(item, index) of icons"
                    :key="index"
                    @click="changeList(item.type, item.iconDec)"
                  >
                    <img class="imgfont" :class="{ checked: item.type == iconIndex }" :src="item.iconContent">
                    <p class="iconDec">{{ item.iconDec }}</p>
                    <p class="iconDec">{{ item.balance }}</p>
                  </div>
                </div>
                <div class="mode1">
                  <div
                    style="cursor: pointer;"
                    class="icon"
                    v-for="(item, index) of iconList"
                    :key="index"
                    @click="changeList(item.type, item.iconDec)"
                  >
                    <img class="imgfont" :class="{ checked: item.type == iconIndex }" :src="item.iconContent">
                    <p class="iconDec">{{ item.iconDec }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="js-liushui">
          <div class="js-liushui-bt"> 收钱吧支付成功，本系统未结算列表</div>
          <el-table :data="pays" v-if="pays.length>0">
            <el-table-column prop="paySn" label="收钱吧单号"/>
            <el-table-column prop="totalPrice" label="金额" width="100"/>
            <el-table-column prop="payTime" label="支付时间"/>
            <el-table-column prop="name" label="类型" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.payType==3">微信</span>
                <span v-if="scope.row.payType==4">支付宝</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="setPay(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="payment-footer">
        <el-button type="primary" class="settlement" :loading="isDisabled" @click="toSaveOrder()">
          {{isDisabled==true?'结算中':'结算'}}
        </el-button>
      </div>
    </el-dialog>


    <el-dialog :close-on-click-modal="false" center :title="zfTitle" :visible.sync="ptVisible" width="400px"
               :before-close="closeCode">
      <div style="margin: 0 auto; text-align: center; width: 100%; height: 100%;margin-top: -20px">
        <div style="padding: 10px">
          <span>{{titleContent}}</span>
        </div>
        <el-input v-model="dynamicId" size="mini" ref="dynamic" style="width: 260px;display: block;margin: auto"
                  placeholder="请输入内容"></el-input>
        <img :src="qrCode" style="width: 150px;height: 150px;">
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      center
      title="混合支付"
      :visible.sync="hhVisible"
      width="400px"
      :before-close="closeHh"
    >
      <div style="margin: 0 auto; text-align: center; width: 100%; height: 100%;margin-top: -20px">
        <el-input v-model="hh.cash" size="mini" class="ei-pay" v-if="pointsMap.xj" placeholder="现金">
          <template slot="prepend" style="width: 85px">现金</template>
        </el-input>
        <el-input placeholder="微信 / 支付宝" v-model="je" :disabled="isDj" class="input-with-select" size="mini"
                  v-if="pointsMap.all"
                  style="width: 260px;margin: auto;margin-bottom: 5px;">
          <el-select v-model="hhPayType" slot="prepend" :disabled="isDj" placeholder="请选择">
            <el-option label="微信" :value="3" v-if="pointsMap.wx"></el-option>
            <el-option label="支付宝" :value="4" v-if="pointsMap.zfb"></el-option>
          </el-select>
        </el-input>
        <el-input v-model="hh.card" size="mini" class="ei-pay" v-if="this.memberCard.id" placeholder="会员卡">
          <template slot="prepend" style="width: 85px">卡金</template>
        </el-input>
        <el-input v-model="hh.give" size="mini" class="ei-pay" v-if="this.memberCard.id" placeholder="欠款">
          <template slot="prepend">赠送金</template>
        </el-input>
        <el-input v-model="hh.arrears" size="mini" class="ei-pay" v-if="this.memberCard.id&&isqk" placeholder="欠款">
          <template slot="prepend">欠款</template>
        </el-input>
        <el-input v-model="hh.sj" size="mini" class="ei-pay" v-if="this.isBtn" placeholder="欠款">
          <template slot="prepend">商家</template>
        </el-input>
      </div>
      <span style="display: flex;flex-direction: row-reverse;margin-top: 5px">
        <el-button size="small" type="primary" style="" @click="jiesuan" :loading="ishhDisabled">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="paysVisible" width="300px" center :before-close="closePays">
      <div class="del-dialog-cnt" style="font-size: 15px">是否选择此支付记录进行结算？</div>
      <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="closePays">取 消</el-button>
            <el-button size="small" type="primary" @click="queren" :loading="querenDisabled">确 定</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
  import {getToken} from "../../../utils/auth";
  import {checkPermission} from "../../../utils/main";

  export default {
    name: "composePay",
    data() {
      return {
        timer: null,
        zfTitle: '',
        dynamicId: "",
        totalAmount: 0,
        iconIndex: 2,
        iconList: [
          {
            iconContent: require("../../../assets/images/xj.png"),
            iconDec: "现金",
            type: "2",
            balance: "",
          },
          {
            iconContent: require("../../../assets/images/wx.png"),
            iconDec: "微信",
            type: "3",
            balance: "",
          },
          {
            iconContent: require("../../../assets/images/zfb.png"),
            iconDec: "支付宝",
            type: "4",
            balance: "",
          },
          {
            iconContent: require("../../../assets/images/hh.png"),
            iconDec: "混合",
            type: "7",
            balance: "",
          },
        ],
        hh: {
          cash: 0,
          wx: 0,
          ali: 0,
          card: 0,
          give: 0,
          arrears: 0,
          sj: 0,
        },

        isDj: false,
        je: 0,
        hhPayType: '',

        isSqb: '',
        paysVisible: false,
        pays: [],

        icons: [],
        loading: false,
        isDisabled: false,
        payNo: "",
        qrCode: "",
        ptVisible: false,
        titleContent: "",
        titleVisible: false,
        ishhDisabled: false,
        querenDisabled: false,

        delVisible: false,
        hhVisible: false,
        isBtn: false,
        pointsMap: {},
        isqk: true,

        createTime: '',
        radio: 1,

        sgnos: [],
      };
    },
    props: {
      payVisible: Boolean,
      total: Number,
      member: Object,
      memberCard: Object,
      data: Object,
    },
    watch: {
      dynamicId(val) {
        if (val != null && val.length == 18) {
          if (this.iconIndex == 7) {
            this.payMethod(this.je, this.hhPayType);
          } else {
            this.payMethod(this.totalAmount, this.iconIndex);
          }
        }
      },
      ptVisible(val) {
        this.isDisabled = val
      }
    },
    async created() {
      await this.getDept()
      this.totalAmount = this.total;
      if (this.memberCard.id) {
        this.icons.push({
          iconContent: require("../../../assets/images/hyk.png"),
          iconDec: "会员卡",
          type: "0",
          balance: this.memberCard.balance
        }, {
          iconContent: require("../../../assets/images/zsj.png"),
          iconDec: "赠送金",
          type: "1",
          balance: this.memberCard.giveBalance
        })
        if (this.isqk) {
          this.icons.push({
            iconContent: require("../../../assets/images/qk.png"),
            iconDec: "欠款",
            type: "8",
          })
        }
        this.iconIndex = 0
      }
    },
    destroyed() {
      // 在页面销毁后，清除计时器
      this.beforeDestroy()
    },
    methods: {
      checkPermission,
      addSgno() {
        this.sgnos.push({sgNo: 0})
      },
      delSgno(index) {
        this.sgnos.splice(index, 1)
      },
      async getDept() {
        let res = await this.$get("/sw/getSwDept", {token: getToken(), memberId: this.data.memberId});
        this.isSqb = res.dept.isSqb
        this.pointsMap = res.pointsMap
        if (res.pointsMap.zfb) {
          this.hhPayType = 4
        }
        if (res.pointsMap.wx) {
          this.hhPayType = 3
        }
        this.isqk = res.isqk
        if (res.dept.isBtn == 0) {
          this.isBtn = true
          this.iconList.push(
            {
              iconContent: require("../../../assets/images/sjia.png"),
              iconDec: "商家",
              type: "9",
              balance: "",
            },
          )
        }
      },
      async getSyPayRecords(index) {
        let res = await this.$get("/sw/getSyPayRecords", {token: getToken(), payType: index});
        this.pays = res.list
      },

      closeEvent() {
        // this.delVisible = true;
        this.closePay()
      },

      closePay() {
        this.$emit("closePay");
      },

      closeCode() {
        this.dynamicId = ''
        this.ptVisible = false;
        this.beforeDestroy()
        this.anniu()
      },

      closeHh() {
        this.dynamicId = ''
        this.isDj = false
        this.je = 0
        this.payNo = ''
        this.hhVisible = false;
        this.anniu()
      },

      closePays() {
        this.paysVisible = false;
        this.anniu()
      },

      fanhui() {
        this.$emit("fanhui");
      },

      jiesuan() {
        this.ishhDisabled = true
        let jine = 0
        if (this.hhPayType == 3 && this.je.toString()) {
          this.hh.ali = 0
          this.hh.wx = this.je
          jine = this.je
        }
        if (this.hhPayType == 4 && this.je.toString()) {
          this.hh.wx = 0
          this.hh.ali = this.je
          jine = this.je
        }
        let b = this.count();
        if (b) {
          if (this.isSqb == 0 && jine != 0) {
            this.toPay(this.hhPayType, jine)
            return;
          }
          this.saveBlendComposeOrder(this.hh)
        }
      },

      queren() {
        this.querenDisabled = true
        if (this.iconIndex == 3 || this.iconIndex == 4) {
          this.saveComposeOrder()
        }
        if (this.iconIndex == 7) {
          this.saveBlendComposeOrder()
        }
      },

      //选择使用的支付记录
      setPay(item) {
        this.payNo = item.payNo
        if (this.iconIndex == 7) {
          this.hhPayType = item.payType
          this.je = item.totalPrice
          this.hhVisible = true
          this.isDj = true
        }
        if (this.iconIndex == 3 || this.iconIndex == 4) {
          if (parseFloat(item.totalPrice) != parseFloat(this.totalAmount)) {
            this.$message.error('金额不统一,无法选择结算！');
            return;
          }
          this.paysVisible = true
        }
      },

      async changeList(index) {
        this.isDisabled = false
        this.pays = []
        this.iconIndex = index;
        if (index == 7) {
          this.getSyPayRecords()
        }
        if (index == 3 || index == 4) {
          this.getSyPayRecords(index)
        }
      },

      async toSaveOrder() {
        this.isDisabled = true
        if (this.iconIndex == 7) {
          this.hhVisible = true
          return;
        }
        if (this.iconIndex == 3 || this.iconIndex == 4) {
          if (this.isSqb == 0) {
            this.toPay(this.iconIndex, this.totalAmount)
            return;
          }
        }
        this.saveComposeOrder()
      },

      async saveComposeOrder() {
        this.data.payType = this.iconIndex
        if (this.radio == 2 && !this.createTime) {
          this.$message.error('请选择补单时间!');
          this.anniu()
          return;
        } else if (this.radio == 2 && this.createTime) {
          this.data.xdTime = this.createTime
        }
        if (this.sgnos.length > 0) {
          let arr = []
          this.sgnos.forEach(item => {
            arr.push(item.sgNo)
          })
          this.data.sgnos = JSON.stringify(arr)
        }
        this.data.payNo = this.payNo
        let res = await this.$post("/sw/saveComposeOrder", this.data);
        if (res.code == 200) {
          this.$router.push('/turnovers/turnover');
        } else {
          this.anniu()
          this.$message.error(res.message);
        }
      },

      async saveBlendComposeOrder(hh) {
        this.data.payType = this.iconIndex
        this.data.blend = JSON.stringify(hh)
        if (this.radio == 2 && !this.createTime) {
          this.$message.error('请选择补单时间!');
          this.anniu()
          return;
        } else if (this.radio == 2 && this.createTime) {
          this.data.xdTime = this.createTime
        }
        this.data.payNo = this.payNo
        let res = await this.$post("/sw/saveBlendComposeOrder", this.data);
        if (res.code == 200) {
          this.$router.push('/turnovers/turnover');
        } else {
          this.anniu()
          this.$message.error(res.message);
        }
      },


      async toPay(status, totalPrice) {
        if (status == 3 || status == 4) {
          if (status == 3) {
            this.zfTitle = '微信支付'
          }
          if (status == 4) {
            this.zfTitle = '支付宝支付'
          }
        }
        this.titleContent = '请您扫码支付'
        let data = {
          token: getToken(),
          payType: status,
          payName: "购买套餐",
          orderId: this.orderId,
          totalPrice: totalPrice
        };
        let res = await this.$post("/sw/precreate", data);
        if (res.code == 200) {
          this.payType = status;
          this.qrCode = res.qrCode;
          this.payNo = res.payNo;
          this.beforeDestroy();
          this.dataRefreh();
          this.ptVisible = true;
          this.$nextTick(() => {
            this.$refs.dynamic.focus() // 设置焦点
          })
        } else {
          this.$message.error(res.message)
        }
      },

      // 定时刷新数据函数
      dataRefreh() {
        // 计时器正在进行中，退出函数
        if (this.timer != null) {
          return;
        }
        // 计时器为空，操作
        this.timer = setInterval(() => {
          this.getPayStatus(); //加载数据函数
        }, 2000);
      },

      // 停止定时器
      beforeDestroy() {
        clearInterval(this.timer); //清除计时器
        this.timer = null; //设置为null
      },

      async getPayStatus() {
        let data = {
          token: getToken(),
          payNo: this.payNo,
        };
        let res = await this.$get("/sw/getPayStatus", data);
        if (res.code == 200) {
          this.titleContent = res.message;
          if (this.iconIndex == 7) {
            this.saveBlendComposeOrder()
          } else {
            this.saveComposeOrder()
          }
          this.beforeDestroy();
        } else {
          this.$message.error("正在支付中")
        }
      },

      async payMethod(totalPrice, payType) {
        if (!this.dynamicId) {
          this.$message.error("请扫付款码");
          return;
        }
        let data = {
          token: getToken(),
          dynamicId: this.dynamicId,
          payType: payType,
          payName: "购买套餐",
          orderId: this.orderId,
          totalPrice: totalPrice,
        };
        let res = await this.$post("/sw/payMethod", data);
        if (res.code == 200) {
          this.payNo = res.payNo
          this.beforeDestroy();
          this.dataRefreh();
        } else {
          this.$message.error(res.message);
        }
      },
      anniu() {
        this.isDisabled = false
        this.ishhDisabled = false
        this.querenDisabled = false
      },

      count() {
        let total = parseInt(this.hh.wx) + parseInt(this.hh.ali) + parseInt(this.hh.card) + parseInt(this.hh.cash) + parseInt(this.hh.arrears) + parseInt(this.hh.sj) + parseInt(this.hh.give)
        if (this.totalAmount != total) {
          this.$message.error("订单价格跟支付价格不统一!")
          this.anniu()
          return false;
        }
        return true;
      },
    },
  };
</script>

<style lang="scss" scoped>


  .swpay-left {
    width: 100%;
    height: 100%;
  }

  .yi-left {
    width: 70%;
    display: inline-block;
    font-size: 14px;
  }

  .yi-right {
    display: inline-block;
    width: 25%;
    text-align: right;
    margin-right: 2%;
  }

  .swpay-choice {
    display: flex;
    flex-direction: row;
    border-bottom: #ececec solid 1px;
    height: auto;

    .mode {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
  }

  .consumption {
    display: flex;
    flex-direction: row;
    border-bottom: #ececec solid 1px;
    height: 40px;
    line-height: 40px;
    padding-left: 40px;
    color: #666666;
  }

  .date-left {
    width: 60%;
    display: inline-block;
    font-size: 14px;
  }

  .date-right {
    display: inline-block;
    width: 50%;
    text-align: right;
  }

  .consumption1 {
    display: flex;
    flex-direction: row;
    border-bottom: #ececec solid 1px;
    padding-left: 40px;
    color: #666666;
  }

  .date-left1 {
    width: 60%;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    min-height: 40px;
  }

  .date-right1 {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: right;
    min-height: 40px;
  }

  .dfsgno {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    padding: 6px 0;
  }

  .dfsgno span {
    height: 25px;
    line-height: 25px;
  }

  //支付方式
  .mode1 {
    // height: 50px;
    margin-bottom: 5px;
    margin-top: 5px;

    .icon {
      width: 55px;
      height: 70px;
      line-height: 40px;
      float: left;
      // margin-left: 10px;
      margin-top: 5px;
      text-align: center;

      .imgfont {
        width: 35px;
        height: 35px;
      }
    }

    .imgfont.checked {
      border-radius: 50%;
      border: #eb2742 solid 1px;
      background-color: #eb2742;
      color: #fff;
    }
  }

  .payment-footer {
    width: 100%;
    height: 15%;
  }

  .settlement {
    width: 100%;
    height: 50px;
    border: 0;
    background-color: #eb2742;
    cursor: pointer;
    color: #fff;
  }

  .iconDec {
    width: 55px;
    margin-top: -20px;
    font-size: 13px;
  }

  .ei-pay {
    width: 260px;
    margin: auto;
    margin-bottom: 5px;
  }

  ::v-deep .el-input-group__prepend {
    width: 45px;
    text-align: center;
  }
</style>
